import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../../Constant/Pagination";
import { CancelRequest } from "../../../services/AxiosInstance";
import DebounceSmallSearchInput from "../../Constant/DebounceSmallSearchInput";
import { Link } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import { FaArrowLeft } from "react-icons/fa";
import {
  deleteExpenseCategoryApi,
  deleteSubCategoryApi,
  getExpenseCategoryApi,
  getSubCategoryApi,
} from "../../../services/ExpenseService";
import AddCategoryModal from "./AddCategoryModal";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import AddSubCategoryModal from "./AddSubCategoryModal";
import { CustomTooltip } from "../../../components/CustomTooltip";
const ExpenseCategorySubCategory = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [categoryError, setCategoryError] = useState("");
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categoryTotal, setCategoryTotal] = useState(0);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [deleteCategoryLoading, setDeleteCategoryLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);
  const [categoryParam, setCategoryParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const [subCategoryData, setSubCategoryData] = useState([]);
  const [subCategoryError, setSubCategoryError] = useState("");
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [subCategoryTotal, setSubCategoryTotal] = useState(0);
  const [addSubCategoryModal, setAddSubCategoryModal] = useState(false);
  const [deleteSubCategoryLoading, setDeleteSubCategoryLoading] =
    useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [deleteSubCategoryModal, setDeleteSubCategoryModal] = useState(false);
  const [subCategoryParam, setSubCategoryParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const handleToggleCategoryAddModal = () => {
    if (addCategoryModal) {
      setSelectedCategory(null);
    }
    setAddCategoryModal(!addCategoryModal);
  };

  const handleToggleDeleteCategoryModal = () => {
    if (deleteCategoryModal) {
      setSelectedCategory(null);
    }
    setDeleteCategoryModal(!deleteCategoryModal);
  };

  const getCategoryData = () => {
    setCategoryLoading(true);
    getExpenseCategoryApi(categoryParam)
      .then((res) => {
        setCategoryError("");
        setCategoryData(res?.data?.results || []);
        setCategoryTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setCategoryError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCategoryLoading(false);
      });
  };
  useEffect(() => {
    getCategoryData();
  }, [categoryParam]);
  const handleCategoryPageChange = (page) => {
    setCategoryParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleCategorySearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setCategoryParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterCategoryAdd = () => {
    handleToggleCategoryAddModal();
    getCategoryData();
  };
  const handleDeleteCategory = () => {
    setDeleteCategoryLoading(true);
    deleteExpenseCategoryApi(selectedCategory?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDeleteCategoryModal();
        getCategoryData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setDeleteCategoryLoading(false);
      });
  };
  const handleToggleSubCategoryAddModal = () => {
    if (addSubCategoryModal) {
      setSelectedSubCategory(null);
    }
    setAddSubCategoryModal(!addSubCategoryModal);
  };

  const handleToggleDeleteSubCategoryModal = () => {
    if (deleteSubCategoryModal) {
      setSelectedSubCategory(null);
    }
    setDeleteSubCategoryModal(!deleteSubCategoryModal);
  };

  const getSubCategoryData = () => {
    setSubCategoryLoading(true);
    getSubCategoryApi(subCategoryParam)
      .then((res) => {
        setSubCategoryError("");
        setSubCategoryData(res?.data?.results || []);
        setSubCategoryTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setSubCategoryError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setSubCategoryLoading(false);
      });
  };
  useEffect(() => {
    getSubCategoryData();
  }, [subCategoryParam]);
  const handleSubCategoryPageChange = (page) => {
    setSubCategoryParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSubCategorySearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setSubCategoryParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterSubCategoryAdd = () => {
    handleToggleSubCategoryAddModal();
    getSubCategoryData();
  };

  const handleDeleteSubCategory = () => {
    setDeleteSubCategoryLoading(true);
    deleteSubCategoryApi(selectedSubCategory?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDeleteSubCategoryModal();
        getSubCategoryData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setDeleteSubCategoryLoading(false);
      });
  };

  return (
    <div className="container-fluid p-0">
      <div className="row g-2">
        <div className="col-md-6">
          <div className="card">
            <div className="p-3 d-flex justify-content-between flex-wrap gap-2">
              <div className="align-self-center">
                <h4 className="m-0 text-primary">Category</h4>
              </div>
              <div className="d-flex gap-1 flex-wrap">
                <div className="flex-fill">
                  <DebounceSmallSearchInput
                    handleSearchChange={handleCategorySearchChange}
                  />
                </div>
                <CustomTooltip title="Add Category">
                  <button
                    className="btn stylish-transparent-btn rounded-2"
                    onClick={handleToggleCategoryAddModal}
                    style={{ padding: "0.5rem" }}
                  >
                    <MdAdd size="22" />
                  </button>
                </CustomTooltip>
              </div>
            </div>
            {categoryLoading ? (
              <div className="text-center my-4">
                <Spinner animation="border" />
              </div>
            ) : categoryError ? (
              <div className="text-center my-4 text-danger">
                {categoryError}
              </div>
            ) : categoryData && categoryData?.length > 0 ? (
              <div className="table-responsive">
                <table className="table fs-6 mb-0 align-middle">
                  <thead className="table-light custom-thead">
                    <tr>
                      <th>Expense Category</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoryData?.map((item, index) => (
                      <tr key={item.id}>
                        <td>{item?.name || "-"}</td>
                        <td>{item?.description || "-"}</td>
                        <td>
                          <div className="d-flex gap-1 align-self-start">
                            <span
                              className="p-1 btn btn-outline-light ms-1"
                              onClick={() => {
                                setSelectedCategory(item);
                                handleToggleCategoryAddModal();
                              }}
                            >
                              <FiEdit2 className="text-dark" size="12" />
                            </span>
                            <span
                              className="p-1 btn btn-outline-light ms-1"
                              onClick={() => {
                                setSelectedCategory(item);
                                handleToggleDeleteCategoryModal();
                              }}
                            >
                              <FiTrash2 className="text-dark" size="12" />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center my-4">No data found</div>
            )}
            {!categoryLoading && categoryData?.length > 0 && (
              <div className="p-4">
                <Pagination
                  currentPage={categoryParam.page}
                  recordsPage={categoryParam.page_size}
                  dataLength={categoryTotal}
                  handlePagination={handleCategoryPageChange}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="p-3 d-flex justify-content-between flex-wrap gap-2">
              <div className="align-self-center">
                <h4 className="m-0 text-primary">Sub-Category</h4>
              </div>
              <div className="d-flex gap-1">
                <div className="flex-fill">
                  <DebounceSmallSearchInput
                    handleSearchChange={handleSubCategorySearchChange}
                  />
                </div>
                <CustomTooltip title="Add Sub category">
                  <button
                    className="btn stylish-transparent-btn rounded-2"
                    onClick={handleToggleSubCategoryAddModal}
                    style={{ padding: "0.5rem" }}
                  >
                    <MdAdd size="22" />
                  </button>
                </CustomTooltip>
              </div>
            </div>
            {subCategoryLoading ? (
              <div className="text-center my-4">
                <Spinner animation="border" />
              </div>
            ) : subCategoryError ? (
              <div className="text-center my-4 text-danger">
                {subCategoryError}
              </div>
            ) : subCategoryData && subCategoryData?.length > 0 ? (
              <div className="table-responsive">
                <table className="table fs-6 mb-0 align-middle">
                  <thead className="table-light custom-thead">
                    <tr>
                      <th>Sub-Category</th>
                      <th>Category</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subCategoryData?.map((item, index) => (
                      <tr key={item.id}>
                        <td>{item?.name || "-"}</td>
                        <td>{item?.expense_category_name || "-"}</td>
                        <td>{item?.description || "-"}</td>
                        <td>
                          <div className="d-flex gap-1 align-self-start">
                            <span
                              className="p-1 btn btn-outline-light ms-1"
                              onClick={() => {
                                setSelectedSubCategory(item);
                                handleToggleSubCategoryAddModal();
                              }}
                            >
                              <FiEdit2 className="text-dark" size="12" />
                            </span>
                            <span
                              className="p-1 btn btn-outline-light ms-1"
                              onClick={() => {
                                setSelectedSubCategory(item);
                                handleToggleDeleteSubCategoryModal();
                              }}
                            >
                              <FiTrash2 className="text-dark" size="12" />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center my-4">No data found</div>
            )}
            {!subCategoryLoading && subCategoryData?.length > 0 && (
              <div className="p-4">
                <Pagination
                  currentPage={subCategoryParam.page}
                  recordsPage={subCategoryParam.page_size}
                  dataLength={subCategoryTotal}
                  handlePagination={handleSubCategoryPageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <AddCategoryModal
        data={selectedCategory || null}
        visible={addCategoryModal}
        onClose={handleToggleCategoryAddModal}
        onAfterSubmit={handleAfterCategoryAdd}
      />

      <AddSubCategoryModal
        data={selectedSubCategory || null}
        visible={addSubCategoryModal}
        onClose={handleToggleSubCategoryAddModal}
        onAfterSubmit={handleAfterSubCategoryAdd}
      />
      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteCategoryModal}
        onClose={handleToggleDeleteCategoryModal}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>
                {selectedCategory?.name || "-"}
              </strong>
              ? This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDeleteCategoryModal}
            color="inherit"
            disabled={deleteCategoryLoading}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={handleDeleteCategory}
          >
            {deleteCategoryLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteSubCategoryModal}
        onClose={handleToggleDeleteSubCategoryModal}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>
                {selectedSubCategory?.name || "-"}
              </strong>
              ? This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDeleteSubCategoryModal}
            color="inherit"
            disabled={deleteSubCategoryLoading}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={handleDeleteSubCategory}
          >
            {deleteSubCategoryLoading && (
              <Spinner animation="border" size="sm" />
            )}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ExpenseCategorySubCategory;
